module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/holiday-exception-dialog/holiday-exception-dialog.component.scss
// module id = 1528
// module chunks = 0